import axios from "axios";
import environment from "environment";

export const urlApiFlow = process.env.REACT_APP_API_FLOW;

const API = (flow:boolean =false) => {

  return axios.create({
    baseURL: flow? urlApiFlow: environment.api.url ,
    timeout: environment.intervals.timeout,
    headers: {
      common: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      "x-helppeople-token": localStorage.getItem('token') ?? ''
    },
  });
};

export default API;
